import { useEffect } from 'react';
import { useSocial } from '../contexts/SocialContext';

/**
 * Loads Meta (Facebook) Pixel base code when an ID is configured in admin settings.
 * Safe to mount multiple times - the script is only added once per ID.
 */
export const FacebookPixel = () => {
  const { social } = useSocial();
  const pixelId = (social?.fbPixelId || '').trim();

  useEffect(() => {
    if (!pixelId) return;
    if (typeof window === 'undefined') return;
    if (window.__fbq_loaded === pixelId) return;
    window.__fbq_loaded = pixelId;

    /* eslint-disable */
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

    // <noscript> pixel fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    img.alt = '';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, [pixelId]);

  return null;
};
